import React, { useState } from 'react';
import Papa from 'papaparse';
import FileUploader from 'devextreme-react/file-uploader';
import { useTranslation } from 'react-i18next';

const CsvEmailsReader = ({ data }) => {
    const { t } = useTranslation();
    const [emails, setEmails] = useState([]);

    const handleFileChange = (e) => {
        const file = e.value[0];

        if (file && file.type === "text/csv") {
            const reader = new FileReader();

            reader.onload = (event) => {
                const csvData = event.target.result;

                Papa.parse(csvData, {
                    header: true,
                    skipEmptyLines: true,
                    complete: (results) => {
                        const emailList = results.data
                            .map(row => row.email?.trim())
                            .filter(email => !!email); // Remove empty/null entries

                        if (data?.setValue && emailList?.length) data.setValue(emailList);
                        setEmails(emailList);
                    },
                    error: (err) => {
                        console.error("Error parsing CSV:", err);
                    }
                });
            };

            reader.readAsText(file);
        } else {
            alert("Please upload a valid CSV file.");
        }
    };

    if (!data?.row?.isNewRow) return null;

    return (
        <div>
            <FileUploader
                accept=".csv"
                allowedFileExtensions={[".csv"]}
                uploadMode="useForm"
                readyToUploadMessage={t("Uploaded")}
                onValueChanged={handleFileChange}
                allowCanceling
            />
            <p className='tw-px-3 tw-font-bold tw-text-lg tw-text-PRIMARY_50'>{`${t("Total")}: ${emails.length || 0} ${t("Email")}`}</p>

        </div>
    );
};

export default CsvEmailsReader;